
    import { Component, Vue, Watch } from "vue-property-decorator";
    import { NotificationPreferences } from "@/models";
    import SaveMsgPopUp from "@/views/shared/SaveMsgPopUp.vue";

    import { namespace } from "vuex-class";
    const profile = namespace("profile");


    @Component({ components: { SaveMsgPopUp } })
    export default class NotificationMgmt extends Vue {

        old_ntfPrefData!: NotificationPreferences;

        sso_changed: boolean = false;
        ssc_changed: boolean = false;
        dna_changed: boolean = false;
        sat_changed: boolean = false;
        sto_changed: boolean = false;
        stoa_changed: boolean = false;
        ra_changed: boolean = false;
        vbto_changed: boolean = false;
        vbtc_changed: boolean = false;

        isModalVisible: boolean = false;
        msgValue: string = '';
        classFlag: string = '';

        @profile.State
        public notificationPrefData!: NotificationPreferences;

        @profile.State
        public profileData!: any;

        mounted() {
            this.getNotificationPrefData();
        }

        async getNotificationPrefData() {
            await this.$store.dispatch('profile/getNotificationPrefDetails', this.profileData.username)
                .then((res: any) => {
                    this.old_ntfPrefData = JSON.parse(JSON.stringify(this.notificationPrefData));
                })
                .catch((err: any) => {
                    if (err) {
                        console.log(err);
                    }
                });
        }

        async saveNotificationDetails() {
            await this.$store.dispatch('profile/saveNotificationPrefDetails', { username: this.profileData.usernam, ntfData: this.notificationPrefData})
                .then((res: any) => {
                    this.sso_changed = false;
                    this.ssc_changed = false;
                    this.dna_changed = false;
                    this.sat_changed = false;
                    this.sto_changed = false;
                    this.stoa_changed = false;
                    this.ra_changed = false;
                    this.vbto_changed = false;
                    this.vbtc_changed = false;

                    this.msgValue = 'Your changes have been saved.';
                    this.classFlag = 'success';
                    this.showModal();
                })
                .catch((err: any) => {
                    if (err) {
                        console.log(err);
                    }
                });
        }

        @Watch('notificationPrefData.selfScheduleOpening')
        onSSOChanges(newValue: boolean) {
            if (this.old_ntfPrefData != undefined) {
                this.sso_changed = (this.old_ntfPrefData.selfScheduleOpening !== newValue ? true : false);
            }
        }

        @Watch('notificationPrefData.selfScheduleClosing')
        onSSCChanges(newValue: boolean) {
            if (this.old_ntfPrefData != undefined) {
                this.ssc_changed = (this.old_ntfPrefData.selfScheduleClosing !== newValue ? true : false);
            }
        }

        @Watch('notificationPrefData.departmentNeedsAvaliable')
        onDNAChanges(newValue: boolean) {
            if (this.old_ntfPrefData != undefined) {
                this.dna_changed = (this.old_ntfPrefData.departmentNeedsAvaliable !== newValue ? true : false);
            }
        }

        @Watch('notificationPrefData.shiftsAvaliableForTrade')
        onSATChanges(newValue: boolean) {
            if (this.old_ntfPrefData != undefined) {
                this.sat_changed = (this.old_ntfPrefData.shiftsAvaliableForTrade !== newValue ? true : false);
            }
        }

        @Watch('notificationPrefData.shiftTradeOffered')
        onSTOChanges(newValue: boolean) {
            if (this.old_ntfPrefData != undefined) {
                this.sto_changed = (this.old_ntfPrefData.shiftTradeOffered !== newValue ? true : false);
            }
        }

        @Watch('notificationPrefData.shiftTradeOfferAccepted')
        onSTOAChanges(newValue: boolean) {
            if (this.old_ntfPrefData != undefined) {
                this.stoa_changed = (this.old_ntfPrefData.shiftTradeOfferAccepted !== newValue ? true : false);
            }
        }

        @Watch('notificationPrefData.requestApproved')
        onRAChanges(newValue: boolean) {
            if (this.old_ntfPrefData != undefined) {
                this.ra_changed = (this.old_ntfPrefData.requestApproved !== newValue ? true : false);
            }
        }

        @Watch('notificationPrefData.vacationBiddingTierOpening')
        onVBTOChanges(newValue: boolean) {
            if (this.old_ntfPrefData != undefined) {
                this.vbto_changed = (this.old_ntfPrefData.vacationBiddingTierOpening !== newValue ? true : false);
            }
        }

        @Watch('notificationPrefData.vacationBiddingTierClosing')
        onVBTCChanges(newValue: boolean) {
            if (this.old_ntfPrefData != undefined) {
                this.vbtc_changed = (this.old_ntfPrefData.vacationBiddingTierClosing !== newValue ? true : false);
            }
        }

        get anyChangeHappened() {    
            let returnVal: boolean = false;
            if (this.sso_changed || this.ssc_changed || this.dna_changed || this.sat_changed || this.sto_changed || this.stoa_changed || this.stoa_changed || this.ra_changed || this.vbto_changed || this.vbtc_changed)
            {
                returnVal = true;
            }
            return returnVal;
        }

        showModal() {
            this.isModalVisible = true;
        }
        closeModal() {
            this.isModalVisible = false;
        }
    }
